const projectTagList = [
  {
    category: '세계',
    tags: ['서울 2033', '새로운 세계관'],
  },
  {
    category: '장르',
    tags: ['근본', '전략', '스토리', '액션', '로맨스', '병맛', '패러디', '코믹', '진지', '추리'],
  },
  {
    category: '기타',
    tags: ['스포일러 주의', '업데이트 중', '2차 창작 환영'],
  },
];

export default projectTagList;
